<template>
  <section @mouseleave="hideDeepNav">
    <template v-if="contents">

      <template v-if="currentTab === 'summary'">
        <link-list
          v-for="(category, categoryIndex) in summaryContents"
          class="deep-nav__group"
          :key="categoryIndex" 
          :heading="category.label"
          :headingUrl="category.url"
          :items="category.content"
        />

        <form class="search" action="/search" autocomplete="off">
          <input type="search" name="terms" class="search__input" placeholder="Search">
          <button type="submit" class="search__submit">Search</button>
        </form>

        <link-list
          v-for="(category, categoryIndex) in contents.find.content"
          class="deep-nav__group"
          :key="categoryIndex" 
          :heading="category.label"
          :headingUrl="category.url"
          :items="category.links"
        />
      </template>

      <template v-else-if="contents.schema === 'custom:news'">
        <news-item
          v-for="(item, index) in contents.content"
          class="deep-nav__news-item"
          :key="`news-item-${index}`"
          :item="item"
        />
      </template>

      <!-- Still under consideration... as with the above, we
      should be able to handle this via the “schema” prop,
      instead of the label (which is _potentially_ volatile).
      At the moment, though, a custom schema isn't delcared! -->
      <template v-else-if="contents.label === 'Events'">
          <div class="deep-nav__event-wrapper">
            <event-list
              v-for="(item, index) in contents.content"
              :key="`event-item-${index}`"
              :item="item"
            />
          </div>
      </template>

      <template v-else-if="contents.schema === 'custom:find'">
        <form class="search" action="/search" autocomplete="off">
          <input type="search" name="terms" class="search__input" placeholder="Search" ref="search">
          <button type="submit" class="search__submit">Search</button>
        </form>

        <link-list
          v-for="(category, categoryIndex) in contents.content"
          v-if="category.links.length > 0"
          class="deep-nav__group"
          :key="categoryIndex" 
          :heading="category.label"link-list deep-nav__group
          :headingUrl="category.url"
          :items="category.links"
        />
      </template>

      <template v-else>
        <link-list
          v-for="(category, categoryIndex) in contents.content"
          class="deep-nav__group"
          v-if="category.links.length > 0"
          :key="categoryIndex" 
          :heading="category.label"
          :headingUrl="category.url"
          :items="category.links"
        />
      </template>
    </template>
  </section>
</template>

<script>
import LinkList from './LinkList.vue'
import NewsItem from './NewsItem.vue'
import EventList from './EventList.vue'
import { EventBus } from '../event-bus.js';

export default {
  name: 'DeepNavSection',

  props: {
    contents: Object,
    currentTab: String
  },

  components: {
    LinkList,
    NewsItem,
    EventList
  },

  computed: {
    // Massage the contents to be displayed on mobile/tablet
    // In this case, exclude the Find tab so it can appear after the search input
    summaryContents () {
      let clone = Object.assign({}, this.contents)
      delete clone.find
      return clone
    }
  },

  mounted () {
    EventBus.$on('focus-search', e => {
      console.log('focused')
      this.focusSearch()
    })
  },

  methods: {
    hideDeepNav () {
      this.$emit('hide-deep-nav', this.contents.label)
    },

    focusSearch () {
      console.log('focused')
      this.$refs.search.focus()
    }
  }
}
</script>


